import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Swal from 'sweetalert2';

import './CategoriasInventarioData.css';
import baseURL from '../../url';

export default function CategoriasInventarioData() {

    const [categorias, setCategorias] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalCrearVisible, setModalCrearVisible] = useState(false);

    const [categoria, setCategoria] = useState({});
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [descripcion, setDescripcion] = useState('');

    useEffect(() => {
        cargarCategorias();
    }, []);

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasinventarioget.php`)
            .then(res => res.json())
            .then(data => {
                setCategorias(Array.isArray(data.categorias) ? data.categorias : []);
            })
            .catch(err => {
                console.error(err);
                toast.error('Error al cargar categorías');
            });
    };

    const abrirModal = (item) => {
        setCategoria(item);
        setNuevaCategoria(item.categoria || '');
        setDescripcion(item.descripcion || '');
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setCategoria({});
        setNuevaCategoria('');
        setDescripcion('');
    };

    const crearCategoria = async () => {

        if (!nuevaCategoria.trim()) {
            toast.error('Escribe una categoría');
            return false;
        }

        try {
            const res = await fetch(`${baseURL}/categoriasinventariopost.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    categoria: nuevaCategoria,
                    descripcion
                })
            });

            const data = await res.json();

            if (data.error) {
                toast.error(data.error);
                return false;
            }

            toast.success('Categoría creada');
            setNuevaCategoria('');
            setDescripcion('');
            cargarCategorias();
            return true;

        } catch (err) {
            console.error(err);
            toast.error('Error al crear categoría');
            return false;
        }
    };

    const handleUpdate = async (idCategoriaInventario) => {

        try {
            const res = await fetch(`${baseURL}/categoriasinventarioput.php`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    idCategoriaInventario,
                    categoria: nuevaCategoria,
                    descripcion
                })
            });

            const data = await res.json();

            if (data.error) {
                Swal.fire('Error', data.error, 'error');
                return;
            }

            Swal.fire(
                            'OK',
                            'Categoria actualizada',
                            'success'
                        );
            cerrarModal();
            cargarCategorias();

        } catch (err) {
            console.error(err);
            Swal.fire('Error', 'No se pudo actualizar', 'error');
        }
    };

    const eliminar = (idcategoria) => {

        Swal.fire({
            title: '¿Eliminar categoría?',
            text: 'No podrás revertir esta acción',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {

            if (!result.isConfirmed) return;

            fetch(`${baseURL}/categoriasinventariodelete.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    idCategoriaInventario: idcategoria
                })
            })
                .then(res => res.json())
                .then(data => {

                    if (data.error || data.status === 'error') {
                        toast.error(data.error || 'No se pudo eliminar');
                        return;
                    }

                    toast.success(data.mensaje || 'Categoría eliminada correctamente');
                    cargarCategorias();
                })
                .catch(err => {
                    console.error(err);
                    toast.error('Error al eliminar categoría');
                });
        });
    };

    return (
        <div className="categoriasInventarioModal">

            {/* ================= BUSCADOR ================= */}
            <div className='deFlexContentBtns'>
                <input
                    className="categoriasInventarioModal__search"
                    placeholder="Buscar categoría..."
                />

                <button
                    className='categoriasInventarioModal__btnPrimary'
                    onClick={() => {
                        setNuevaCategoria('');
                        setDescripcion('');
                        setModalCrearVisible(true);
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    &nbsp; Nueva categoría
                </button>
            </div>

            {/* ================= CREAR ================= */}
            {modalCrearVisible && (
                <div className="modal">
                    <div className="categoriasInventarioModal__content">

                        <span className="close" onClick={() => setModalCrearVisible(false)}>
                            &times;
                        </span>

                        <h3>Nueva categoría</h3>

                        <fieldset className="categoriasInventarioModal__field">
                            <legend>Nombre</legend>
                            <input
                                value={nuevaCategoria}
                                onChange={e => setNuevaCategoria(e.target.value)}
                            />
                        </fieldset>

                        <fieldset className="categoriasInventarioModal__field">
                            <legend>Descripción</legend>
                            <textarea
                                value={descripcion}
                                onChange={e => setDescripcion(e.target.value)}
                            />
                        </fieldset>

                        <div className="modal-actions">
                            <button
                                className="btn-cancel"
                                onClick={() => setModalCrearVisible(false)}
                            >
                                Cancelar
                            </button>

                            <button
                                className="btn-save"
                                onClick={async () => {
                                    const ok = await crearCategoria();
                                    if (ok) setModalCrearVisible(false);
                                }}
                            >
                                Guardar
                            </button>
                        </div>

                    </div>
                </div>
            )}

            {/* ================= EDITAR ================= */}
            {modalVisible && (
                <div className="modal">
                    <div className="categoriasInventarioModal__content">

                        <span className="close" onClick={cerrarModal}>
                            &times;
                        </span>

                        <h3>Editar categoría</h3>

                        <fieldset>
                            <legend>Nombre</legend>
                            <input
                                value={nuevaCategoria}
                                onChange={e => setNuevaCategoria(e.target.value)}
                            />
                        </fieldset>

                        <fieldset>
                            <legend>Descripción</legend>
                            <textarea
                                value={descripcion}
                                onChange={e => setDescripcion(e.target.value)}
                            />
                        </fieldset>

                        <div className="modal-actions">
                            <button className="btn-cancel" onClick={cerrarModal}>
                                Cancelar
                            </button>

                            <button
                                className="btn-save"
                                onClick={() => handleUpdate(categoria.idCategoriaInventario)}
                            >
                                Guardar
                            </button>
                        </div>

                    </div>
                </div>
            )}

            {/* ================= LISTA ================= */}
            <div className='table-container'>
                <div className='table'>
                    <div id='tbody'>

                        {categorias.length > 0 ? categorias.map(item => (
                            <div key={item.idCategoriaInventario} className='CategoriConten'>

                                <div>
                                    <strong>{item.categoria}</strong>
                                    <p style={{ marginTop: 5, color: '#777' }}>
                                        {item.descripcion}
                                    </p>
                                </div>

                                <div className="categoriasInventarioModal__actions">

                                    <button
                                        className="categoriasInventarioModal__btnEdit"
                                        onClick={() => abrirModal(item)}
                                    >
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>

                                    <button
                                        className="categoriasInventarioModal__btnDelete"
                                        onClick={() => eliminar(item.idCategoriaInventario)}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>

                                </div>

                            </div>
                        )) : (
                            <div style={{ textAlign: 'center', padding: 30 }}>
                                No existen categorías
                            </div>
                        )}

                    </div>
                </div>
            </div>

            <ToastContainer />

        </div>
    );
}